exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-container[data-v-1a22e658]{overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-1a22e658","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/specialDictionary/assayCategory/index.vue
// module id = nEFG
// module chunks = 66 239